module.exports = __webpack_public_path__ + "static/media/aplicacao.5df6e4b4.png";